import React, { useState, useEffect } from 'react';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import Hero from './components/sections/Hero';
import About from './components/sections/About';
import Education from './components/sections/Education';
import Experience from './components/sections/Experience';
import Projects from './components/sections/Projects';
import Skills from './components/sections/Skills';
import Contact from './components/sections/Contact';
import { Toaster } from './components/ui/toast';

const App = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simulate loading time
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 350);
    
    return () => clearTimeout(timer);
  }, []);

  if (isLoading) {
    return (
      <div className="h-screen w-screen flex items-center justify-center bg-background">
        <div className="terminal-window w-full max-w-md">
          <div className="terminal-header">
            <div className="terminal-button terminal-button-red"></div>
            <div className="terminal-button terminal-button-yellow"></div>
            <div className="terminal-button terminal-button-green"></div>
            <div className="terminal-title">initializing...</div>
          </div>
          <div className="terminal-body">
            <div className="terminal-output">
              <span className="terminal-prompt">$</span>{' '}
              <span className="terminal-command">./initialize_portfolio.sh</span>
              <div className="mt-2">
                Loading Furkan Öztürk assets... <span className="text-primary">Done</span>
              </div>
              <div>
                Establishing secure connection... <span className="text-primary">Done</span>
              </div>
              <div>
                Verifying credentials... <span className="text-primary">Done</span>
              </div>
              <div className="mt-2">Launching portfolio interface...</div>
            </div>
            <div className="flex items-center">
              <span className="terminal-prompt">$</span>{' '}
              <span className="cursor"></span>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background text-foreground relative overflow-hidden gradient-bg noise">
      <Toaster />
      <div className="relative z-10">
        <Header />
        <main>
          <Hero />
          <About />
          <Experience />
          <Education />
          <Projects />
          <Skills />
          <Contact />
        </main>
        <Footer />
      </div>
    </div>
  );
};

export default App;